import { render, staticRenderFns } from "./place_primary_inspections.vue?vue&type=template&id=0a2e1396&scoped=true&"
import script from "./place_primary_inspections.vue?vue&type=script&lang=js&"
export * from "./place_primary_inspections.vue?vue&type=script&lang=js&"
import style0 from "./place_primary_inspections.vue?vue&type=style&index=0&id=0a2e1396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2e1396",
  null
  
)

export default component.exports